module.exports = __webpack_public_path__ + "static/media/skype.4d88f8c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/skype.svg
// module id = 767
// module chunks = 0